module.exports = __webpack_public_path__ + "media/images/book-img-02-3a42e5f5e5cb3ba146904ea960c1365d.png";